export default __webpack_public_path__ + "navigation-overview-setup-ib-segue-960-9da9d6473bc95ed6732b7aad887ebf7c.webp";